var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  width: 12.729,
  height: 14,
  viewBox: "0 0 12.729 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8.273,14H1.91A1.912,1.912,0,0,1,0,12.091v-7a.637.637,0,0,1,.246-.5L5.973.134A.631.631,0,0,1,6.364,0a.624.624,0,0,1,.39.134l5.729,4.454a.638.638,0,0,1,.246.5v7A1.912,1.912,0,0,1,10.819,14Zm2.546-1.273a.638.638,0,0,0,.637-.636V5.4L6.364,1.442,1.273,5.4v6.69a.637.637,0,0,0,.637.636H3.819V7a.637.637,0,0,1,.637-.637H8.273A.637.637,0,0,1,8.91,7v5.727Zm-3.181,0V7.636H5.091v5.091Z",
  fill: "inherit"
})));
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "static/media/home.aa751c37215ebf4eef28389d7c7e17c2.svg";